import React, {useEffect, useState} from "react";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {config} from "../../../../config";
import {Col, Row} from "reactstrap";
import {Formik} from "formik";
import QButton from "../../../../common/components/QButton";
import {useDispatch} from "react-redux";
import {setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import {SetupInterface} from "../../../../interfaces/private/SetupInterface";
import {useTranslation} from "react-i18next";
import QSelect from "../../../../common/components/QSelect";
import {SelectOptionInterface} from "../../../../interfaces/SelectOptionInterface";
import {
    CustomerGroupInterface,
    PaymentTermInterface,
    ProductGroupInterface,
} from "../../../../interfaces/economic/CommonInterface";

interface Props {
    model: SetupInterface;
    setOpen: Function;
    setLoadingFunc: Function;
    setSetup: Function;
    setup: SetupInterface;
    allDataSetup: any;
}

const BodyCommonSetupComponent: React.FC<Props> = ({
    allDataSetup,
    setOpen,
    setLoadingFunc,
    setSetup,
    setup,
}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);

    const {customerGroups, productGroups, paymentTerms} = allDataSetup;

    useEffect(() => {
        if (loading) {
            load().then(async () => {
                setLoading(false);
            });
        }
    }, [loading]);

    const load = async () => {
        try {
            await SetupApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setSetup(response?.data?.data || {});
                }
            });
        } catch (err) {
            // ignore
        }
        if (loading) {
            await setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Formik
                initialValues={{...setup}}
                onSubmit={(values: any) => {
                    SetupApi.update(values).then(async (response: ResponseInterface | any) => {
                        if (response.status === config.STATUS_CODE.OK) {
                            setSetup(response?.data?.data || {});
                            await setOpen(false);
                            await setLoadingFunc(true);
                            await dispatch(setToast({
                                message: t("economic.updateSuccess"),
                                type: config.TOAST_TYPE.SUCCESS,
                            }));
                        }
                    });
                }}
            >
                {(formik) => (
                    <React.Fragment>
                        <Row>
                            <Col>
                                <QSelect
                                    label={t("economic.customerGroup")}
                                    value={parseInt(formik.values.economic_customer_group_number)}
                                    onChange={(option: SelectOptionInterface) => {
                                        formik.setFieldValue("economic_customer_group_number", option.value);
                                    }}
                                    options={customerGroups.map((a: CustomerGroupInterface) => ({
                                        label: a.name,
                                        value: a.customerGroupNumber,
                                    }))}
                                    error={formik.errors?.economic_customer_group_number}
                                />
                                <QSelect
                                    label={t("economic.customerPaymentTerms")}
                                    value={parseInt(formik.values.economic_customer_payment_terms_number)}
                                    onChange={(option: SelectOptionInterface) => {
                                        formik.setFieldValue("economic_customer_payment_terms_number", option.value);
                                    }}
                                    options={paymentTerms.map((a: PaymentTermInterface) => ({
                                        label: a.name,
                                        value: a.paymentTermsNumber,
                                    }))}
                                    error={formik.errors?.economic_customer_payment_terms_number}
                                />
                                <QSelect
                                    label={t("economic.productGroup")}
                                    value={parseInt(formik.values.economic_product_group_number)}
                                    onChange={(option: SelectOptionInterface) => {
                                        formik.setFieldValue("economic_product_group_number", option.value);
                                    }}
                                    options={productGroups.map((a: ProductGroupInterface) => ({
                                        label: a.name,
                                        value: a.productGroupNumber,
                                    }))}
                                    error={formik.errors?.economic_product_group_number}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <div className="d-flex justify-content-end gap-2">
                                    <QButton
                                        type="default"
                                        onClick={() => {
                                            setOpen(false);
                                        }}
                                        content={t("common.button.cancel")}
                                    />
                                    <QButton
                                        type="primary"
                                        onClick={() => {
                                            formik.handleSubmit();
                                        }}
                                        content={t("common.button.submit")}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </Formik>
        </React.Fragment>
    );
};

export default BodyCommonSetupComponent;
